import React, {useEffect, useState, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import {ContentContext} from "../common/ContentContext";
import {TemplateContext} from "../common/TemplateContext";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import useCurrentConcept from "../hooks/useCurrentConcept";
import {ArrowRightIcon} from "../common/icons";
import Button from "../common/Button";

const MyCourseLastLessonDashboardWidget = props => {
    const {...other} = props;
    const {content} = useContext(ContentContext);
    const brandConfig = useContext(BrandContext);
    const {user} = useContext(UserContext);
    const {isSeriesNavVisible, setSeriesNavVisible} = useContext(TemplateContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [isLoading, setLoading] = useState(true);
    const [lastConcept, setLastConcept] = useState();

    const loadLastConcept = () => {
        if(content.currentConcept === undefined || content.currentConcept.conceptId == undefined) {
            setLoading(false);
            return;
        }

        setLoading(true);
        axios.get('/web/ui/content/concept/' + content.currentConcept.conceptId)
            .then(response => {
                setLastConcept(response.data);
                setLoading(false);
            });
    }
    const handleLoadConcept = conceptId => {
        loadCurrentConcept(conceptId);
    }

    const handleChangeSyllabus = () => {
        setSeriesNavVisible(true)
    }

    useEffect(() => {
        loadLastConcept();
    }, []);

    useEffect(() => {
        $('.ch-dashboard-blk-body .ch-mathjax').reloadMathJax();
    }, [lastConcept,]);

    if (lastConcept === undefined) {
        return (
            <DashboardWidget
                title={
                    <div className="ch-dashboard-title-with-icon">
                        <svg className="ch-icon-medium" viewBox="0 0 128 128">
                            <use href="#navLessons-icon"></use>
                        </svg>
                        <span>My {brandConfig.syllabusName.toLowerCase()}</span>
                    </div>
                }
                isLoading={isLoading}
                {...other}>
                <div className={'ch-dashboard-blk-body'}>
                    <div>This is the portal for you to access all of your <strong>{user.syllabusName}</strong> content.</div>
                </div>
                <div className={'ch-dashboard-blk-footer align-right'}>
                    <Button type="text"
                            onClick={() => handleChangeSyllabus()}>
                        <span>Change {brandConfig.syllabusName}</span>
                    </Button>
                </div>
            </DashboardWidget>
        )
    }

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#lastLesson-icon"></use>
                    </svg>
                    <span>Last {brandConfig.conceptName.toLowerCase()} viewed</span>
                </div>
            }
            isLoading={isLoading}
            {...other}>
            <div className={'ch-dashboard-blk-body'} style={{'overflowY': 'unset'}}>
                <p className="text-muted ch-mathjax padding-b--s" dangerouslySetInnerHTML={{ __html: lastConcept.topicName}}/>
                {lastConcept !== undefined &&
                    <Button className="ch-mathjax" type="outline"
                            style={{justifyContent: 'space-between', width: '100%'}}
                            onClick={() => handleLoadConcept(lastConcept.conceptId)}>
                        <span style={{overflow: 'hidden', textOverflow: 'ellipsis'}} dangerouslySetInnerHTML={{ __html: lastConcept.conceptName}}/>
                        <span><ArrowRightIcon height={20} width={20} /></span>
                    </Button>
                }
            </div>
            <div className={'ch-dashboard-blk-footer align-right'}>
                <Button className="ch-mathjax" type="text"
                        onClick={() => handleChangeSyllabus()}>
                    <span>Change {brandConfig.syllabusName}</span>
                </Button>
            </div>
        </DashboardWidget>
    )
}

export default MyCourseLastLessonDashboardWidget;